import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap FIRST
import "./index.css";
import "./styles/utils/animate.css"; // Animation styles
import "./styles/themes/tealTheme.css"; // Then override with teal theme
import App from "./App";
import "./styles/themes/darkTheme.css"; // Then dark mode overrides
import { ThemeProvider } from "./contexts/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Removed AuthProvider - authentication is now handled directly in App
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
